(function(angular){
  'use strict';

  angular.module('math.filters', []);
}(window.angular));
